/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFilesMode: {
  name: 'files-mode';
  data: string;
} = {
  name: 'files-mode',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 2h5a1 1 0 1 1 0 2H7v4h7a1 1 0 1 1 0 2H7v4h9a1 1 0 1 1 0 2H7v4h11a1 1 0 1 1 0 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z" fill="currentColor"/></svg>`,
};
